import React from 'react';
import { IonIcon } from '@ionic/react';
import { ellipsisVertical } from 'ionicons/icons';
import { pxToRem } from '@/modules/config';
import '@/components/Interstitial.css';

/** Anchor ids `HomeInstallNudgeBlock`'s links scroll the sheet to. */
export const HOME_INSTALL_ANCHOR = 'welcome-install';
export const HOME_INSTALL_WHY_ANCHOR = 'welcome-convince';

/**
 * The welcome sheet's detail zone — only visible once the sheet is dragged (or
 * linked) to full height: how to add Snowball to the Home Screen, and why it is
 * worth doing.
 */
const HomeInstallDetailBlocks: React.FC = () => (
  <>
    <hr className="interstitial__section-rule" />

    <div id={HOME_INSTALL_ANCHOR}>
      <p className="interstitial__section-heading">Add to Home Screen</p>

      {/* TODO: Replace with hosted tutorial video URL */}
      <div
        style={{
          background: '#f0f0f0',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 160,
          margin: '0 20px 16px',
        }}
      >
        <span style={{ color: '#999', fontSize: pxToRem(14) }}>
          Video coming soon
        </span>
      </div>

      <ol
        className="interstitial__body"
        style={{ paddingLeft: 36, paddingTop: 0 }}
      >
        <li>
          Tap the 3-dot menu{' '}
          <IonIcon
            icon={ellipsisVertical}
            style={{ verticalAlign: 'middle', fontSize: '1em' }}
          />{' '}
          in the toolbar
        </li>
        <li>
          Tap <strong>Add to Home screen</strong> or{' '}
          <strong>Install App</strong>
        </li>
        <li>
          Tap <strong>Install</strong>
        </li>
      </ol>
    </div>

    <hr className="interstitial__section-rule" />

    <div id={HOME_INSTALL_WHY_ANCHOR}>
      <p className="interstitial__section-heading">Why bother?</p>
      <p className="interstitial__body">
        Adding Snowball to your Home Screen gives you a full-screen experience.
        It takes about 10 seconds, and you&apos;ll never have to hunt for the
        link again.
      </p>
    </div>

    {/* Bottom padding so last section isn't flush against the edge */}
    <div style={{ height: 40 }} />
  </>
);

export default HomeInstallDetailBlocks;
